module.exports = __webpack_public_path__ + "img/print_lipsprint@2x.0442e2a.jpg";